// @flow
import React, { PureComponent } from "react"
import { connect } from "react-redux"
import type { Node } from "react"

import {
  removeItem as _removeItem,
  removeAllItems as _removeAllItems,
  setItems as _setItems,
} from "common/services/starred/starredDuck"
import { storeFindItem } from "common/records/Starred"
import type { StarredStore, StarredItem } from "common/records/Starred.types"
import type Journey from "common/records/Journey"
import type PassengersCount from "common/records/PassengersCount"
import type { CabinClass } from "common/records/CabinClass"
import Translate from "../../../../app/scripts/components/Translate"

type Props = {|
  children: (
    Node,
    (Journey, PassengersCount, CabinClass) => void,
    (StarredItem, SyntheticEvent<*>) => void,
  ) => Node,
  starredStore: StarredStore,
  removeAllItems: typeof _removeAllItems,
  setItems: typeof _setItems,
  removeItem: typeof _removeItem,
|}

type State = {|
  backupItems: ?Array<StarredItem>,
|}

class StarredTripsList extends PureComponent<Props, State> {
  state = {
    backupItems: null,
  }

  handleUnstarAll = (e: SyntheticEvent<*>) => {
    e.stopPropagation()
    e.preventDefault()

    const { starredStore, removeAllItems } = this.props

    removeAllItems()

    this.setState({
      backupItems: starredStore.items,
    })
  }

  handleUndo = (e: SyntheticEvent<*>) => {
    e.stopPropagation()
    e.preventDefault()

    const { backupItems } = this.state
    const { setItems } = this.props

    if (backupItems) {
      setItems(backupItems)

      this.setState({
        backupItems: null,
      })
    }
  }

  handleToggleStar = (journey: Journey, passengers: PassengersCount, cabinClass: CabinClass) => {
    const { starredStore, removeItem } = this.props

    const item = storeFindItem(starredStore, journey, passengers, cabinClass)

    if (item) {
      removeItem(item.id)
    }
  }

  handleRemoveStar = (item: StarredItem, e: SyntheticEvent<*>) => {
    e.stopPropagation()
    e.preventDefault()
    this.props.removeItem(item.id)
  }

  render() {
    const { starredStore, children } = this.props
    const { backupItems } = this.state

    const hasUndo = Boolean(backupItems)

    const actionButton = hasUndo ? (
      <a className="StarredTripsList-action _undo" onClick={this.handleUndo}>
        <Translate tKey="starred.undo_unstar" />
      </a>
    ) : (
      starredStore.items.length > 0 && (
        <a className="StarredTripsList-action _unstar" onClick={this.handleUnstarAll}>
          <Translate tKey="starred.unstar_all_trips" />
        </a>
      )
    )

    return children(actionButton, this.handleToggleStar, this.handleRemoveStar)
  }
}

// $FlowFixMe TODO: plz add type when updating
export default connect(
  state => ({
    starredStore: state.starred,
  }),
  {
    removeItem: _removeItem,
    removeAllItems: _removeAllItems,
    setItems: _setItems,
  },
)(StarredTripsList)
